import React from 'react';

const Logo = () => {
  return (
    <svg width="130pt" height="28pt" viewBox="0 0 1477.99 306.5" version="1.1">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="128.89"
          y1="241.57"
          x2="160.68"
          y2="99.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.24" stopColor="#00149e" />
          <stop offset="0.37" stopColor="#10239f" />
          <stop offset="0.58" stopColor="#2335a0" />
          <stop offset="0.79" stopColor="#2f3fa1" />
          <stop offset="1" stopColor="#3343a1" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="49.72"
          y1="241.41"
          x2="254.33"
          y2="67.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#4456b3" />
          <stop offset="1" stopColor="#f0f0f4" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="22.55"
          y1="274.84"
          x2="215.29"
          y2="150.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6672b8" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="121.17"
          y1="159.98"
          x2="275.24"
          y2="52.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.29" stopColor="#3343a1" />
          <stop offset="0.47" stopColor="#4352a8" />
          <stop offset="0.8" stopColor="#5d69b4" />
          <stop offset="1" stopColor="#6672b8" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1="177.2"
          y1="131.42"
          x2="238.34"
          y2="20.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3343a1" />
          <stop offset="1" stopColor="#ebecf0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="193.22"
          y1="142.07"
          x2="265.72"
          y2="3.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6672b8" />
          <stop offset="0.18" stopColor="#929bcd" />
          <stop offset="0.43" stopColor="#cdd1e8" />
          <stop offset="0.62" stopColor="#f1f2f9" />
          <stop offset="0.71" stopColor="#fff" />
        </linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            style={{ fill: 'url(#linear-gradient)' }}
            d="M282.88,235A153.24,153.24,0,1,1,45.62,44.19C60,48.91,75,56.47,87.61,68.52c38.32,36.69,27.7,75,59.5,119S251.53,201.83,282.88,235Z"
          />
          <path
            style={{ fill: 'url(#linear-gradient-2)' }}
            d="M282.88,235A153.24,153.24,0,1,1,45.62,44.19C35.78,65,16.22,170.25,109.82,212.3,159.35,234.55,251.53,201.83,282.88,235Z"
          />
          <path
            style={{ fill: 'url(#linear-gradient-3)' }}
            d="M253.65,269A153.25,153.25,0,0,1,0,153.24c0-42.68-2.65,83.58,99.26,95.53,35.06,4.1,56.49-4.66,100.16.58C233.12,253.39,259.65,263.83,253.65,269Z"
          />
          <path
            style={{ fill: 'url(#linear-gradient-4)' }}
            d="M306.51,153.24a152.85,152.85,0,0,1-10.15,54.92c-40.43-2.83-94.75-23.59-104.62-79C172.78,22.77,111,44.19,77,20.32A153.28,153.28,0,0,1,306.51,153.24Z"
          />
          <path
            style={{ fill: 'url(#linear-gradient-5)' }}
            d="M306.51,153.24a152.85,152.85,0,0,1-10.15,54.92c-33.49,0-54.86-50.74-63.66-104.08C218.43,17.67,141.44,59.31,77,20.32A153.28,153.28,0,0,1,306.51,153.24Z"
          />
          <path
            style={{ fill: 'url(#linear-gradient-6)' }}
            d="M306.51,153.24c0,6.54-14.78,2-29-10.22-23.66-20.31-37.66-48.13-49.5-81.89C208.31,4.92,125.49,0,153.27,0A153.23,153.23,0,0,1,306.51,153.24Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M523.8,108.45C510.11,100.56,494.59,95,475.9,95c-36.32,0-64.75,26.32-64.75,63.69,0,36.59,28.43,64,67.64,64,17.9,0,33.17-5.26,47.12-14l14.47,34c-16.58,11.06-41.06,18.43-62.64,18.43C412.47,261.11,368,217.68,368,158.72c0-58.16,45.27-102.64,106.33-102.64A122.93,122.93,0,0,1,538.8,73.71Z"
          />
          <path style={{ fill: '#fff' }} d="M578,258V59.24H619.6V220.31H702V258Z" />
          <path
            style={{ fill: '#fff' }}
            d="M898.84,258l-2.63-107.39-57.9,76.86h-4.48l-58.69-76.86L773.3,258H733l9-200.56,5.79-.52L837,173.72,924.11,56.87l6,.52,9,200.56Z"
          />
          <path style={{ fill: '#fff' }} d="M989.74,185.27V136.66h7.66v41.66h21.7v7Z" />
          <path style={{ fill: '#fff' }} d="M1028.05,185.27V136.66h7.66v48.61Z" />
          <path style={{ fill: '#fff' }} d="M1056.57,143.61v15h19.19v6.76h-19.19v19.9h-7.66V136.66h29.36v7Z" />
          <path style={{ fill: '#fff' }} d="M1087.74,185.27V136.66h29.36v7h-21.7V157.2H1115V164H1095.4v14.36h21.7v7Z" />
          <path
            style={{ fill: '#fff' }}
            d="M1163.52,146.77a27.23,27.23,0,0,0-13.07-3.74c-10.62,0-17.77,7.6-17.77,18s7.41,18,18.35,18a26.3,26.3,0,0,0,13-3.8l2.57,6.31A29.85,29.85,0,0,1,1150.9,186c-15.45,0-26.27-10.56-26.27-25,0-14.3,11.08-25.11,25.89-25.11a31.06,31.06,0,0,1,15.9,4.44Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1196.42,164.6v20.67h-7.59V164.54l-17.07-27.88h8.63l12.43,21.05,12.23-21.05h8.5Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1255.15,146.77a27.29,27.29,0,0,0-13.07-3.74c-10.63,0-17.78,7.6-17.78,18s7.41,18,18.36,18a26.29,26.29,0,0,0,13-3.8l2.58,6.31a29.9,29.9,0,0,1-15.71,4.57c-15.46,0-26.27-10.56-26.27-25,0-14.3,11.07-25.11,25.88-25.11a31,31,0,0,1,15.9,4.44Z"
          />
          <path style={{ fill: '#fff' }} d="M1268.15,185.27V136.66h7.66v41.66h21.7v7Z" />
          <path
            style={{ fill: '#fff' }}
            d="M1306.14,185.27V136.66h29.36v7h-21.7V157.2h19.64V164H1313.8v14.36h21.7v7Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1030.37,262.55l-.71-31.61-15.77,22.66H1013L997.08,231l-.52,31.55H989l2-49.32,1.22-.13,21.44,30.33,20.93-30.33,1.22.13,2.06,49.32Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1082.39,262.55l-5-11.65h-19.77l-5,11.65h-7.85l22.21-49.45h1.16l22.21,49.45Zm-14.81-35.15-7.34,17.45h14.62Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1136.29,263.58l-30.52-33.48v32.45h-7.67V213.17l1.29-.26L1129.65,246V213.94h7.67v49.39Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1182.52,262.55l-5-11.65h-19.77l-5,11.65H1145l22.21-49.45h1.16l22.21,49.45Zm-14.81-35.15-7.34,17.45H1175Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1237.82,237.18V258a30.93,30.93,0,0,1-18,5.35c-13.78,0-25.82-10-25.82-25,0-15.19,12.29-25.17,25.69-25.17a30.65,30.65,0,0,1,17.45,5.21l-3.55,6.05a25.55,25.55,0,0,0-13.58-4.24c-11.46,0-18,8.37-18,18,0,10.69,8,18.35,18.16,18.35a21.9,21.9,0,0,0,10.24-2.31V244h-11.65v-6.83Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1249.48,262.55V213.94h29.36v6.95h-21.7v13.59h19.64v6.76h-19.64V255.6h21.7v7Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1330.74,262.55l-.71-31.61-15.78,22.66h-.9l-15.9-22.6-.52,31.55h-7.53l2-49.32,1.23-.13,21.44,30.33L1335,213.1l1.22.13,2.06,49.32Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1350.44,262.55V213.94h29.36v6.95h-21.7v13.59h19.64v6.76H1358.1V255.6h21.7v7Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1429.25,263.58l-30.52-33.48v32.45h-7.66V213.17l1.28-.26L1422.62,246V213.94h7.66v49.39Z"
          />
          <path style={{ fill: '#fff' }} d="M1462.47,220.89v41.66h-7.66V220.89h-15.58v-6.95H1478v6.95Z" />
          <path
            style={{ fill: '#fff' }}
            d="M1026.15,69.6a27.33,27.33,0,0,0-13.06-3.73c-10.62,0-17.76,7.59-17.76,17.95s7.4,18,18.34,18a26.22,26.22,0,0,0,13-3.8l2.58,6.31a30,30,0,0,1-15.7,4.57c-15.44,0-26.25-10.55-26.25-25,0-14.28,11.07-25.09,25.86-25.09A31.09,31.09,0,0,1,1029,63.17Z"
          />
          <path style={{ fill: '#fff' }} d="M1039.14,108.07V59.5h7.66v41.63h21.68v6.94Z" />
          <path style={{ fill: '#fff' }} d="M1077.42,108.07V59.5h7.66v48.57Z" />
          <path
            style={{ fill: '#fff' }}
            d="M1098.26,108.07V59.5h29.34v7h-21.68V80h19.62v6.75h-19.62v14.35h21.68v6.94Z"
          />
          <path
            style={{ fill: '#fff' }}
            d="M1177,109.1l-30.5-33.45v32.42h-7.65V58.73l1.28-.26,30.24,33.07v-32H1178v49.35Z"
          />
          <path style={{ fill: '#fff' }} d="M1210.2,66.45v41.62h-7.66V66.45H1187v-7h38.72v7Z" />
        </g>
      </g>
    </svg>
  );
};
export default Logo;
